import { render, staticRenderFns } from "./payg-upgrade-complete.vue?vue&type=template&id=f5ed5568&"
import script from "./payg-upgrade-complete.vue?vue&type=script&lang=js&"
export * from "./payg-upgrade-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports